import { defineComponent as ie, mergeModels as F, ref as v, useModel as re, useAttrs as ce, computed as o, onMounted as ve, onUnmounted as de, reactive as fe, provide as pe, openBlock as i, createElementBlock as d, normalizeClass as p, unref as b, renderSlot as k, createBlock as _, createCommentVNode as f, withDirectives as ye, mergeProps as z, createElementVNode as A, toDisplayString as y, Fragment as me, renderList as he, vModelSelect as be, vShow as Se, withCtx as I, createVNode as w, createTextVNode as ge } from "vue";
import { InputSize as Ce, InputVariant as r, getInputLabelStyleClasses as ke, getInputFieldStyleClasses as Ae, getCustomSelectIconStyleClasses as Ie, getCustomSelectOptionIconStyleClasses as xe, getCustomSelectDropdownActivatorStyleClasses as _e, getCustomSelectLabelTextStyleClasses as we, getCustomSelectedLabelStyleClasses as Le, getCustomSelectChevronStyleClasses as Be, CustomSelectListSymbol as De } from "./novoui-vuejs62.js";
import L from "./novoui-vuejs12.js";
import $e from "./novoui-vuejs22.js";
import Te from "./novoui-vuejs9.js";
import Ee from "./novoui-vuejs819.js";
const Me = ["name", "data-testid", "disabled"], Ne = ["checked"], Re = ["checked"], Fe = ["checked"], ze = ["value"], Oe = ["value"], Pe = ["onClick", "data-testid"], Ve = {
  key: 2,
  class: "select-custom-selected-type-label"
}, Ke = /* @__PURE__ */ ie({
  inheritAttrs: !1,
  __name: "NSelect",
  props: /* @__PURE__ */ F({
    size: { default: Ce.medium },
    icon: {},
    leadingIcon: {},
    options: {},
    native: { type: Boolean, default: !0 },
    name: { default: void 0 },
    multiselect: { type: Boolean, default: !1 },
    variant: { default: r.fill },
    assistiveText: {},
    errorMessage: {},
    modelValue: {},
    label: { default: void 0 },
    placeholder: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ F([
    /**
     * The event emitted on input value change
     */
    "update:modelValue"
  ], ["update:modelValue"]),
  setup(B, { expose: O, emit: P }) {
    const D = v();
    O({ inputExposed: D });
    const l = re(B, "modelValue"), c = v(), h = v(), x = v(), S = v(), $ = v(), T = v(), { class: V, ...g } = ce(), E = v(!1), j = P, U = o(() => ke(t)), M = o(() => Ae(t.variant)), H = o(() => Ie(t)), q = o(() => xe(t)), G = o(() => _e(t, m.value)), J = o(
      () => !l.value || Array.isArray(l.value) && l.value.length === 0 ? "selection-colors-pristine" : ""
    ), K = o(
      () => (t.variant === r.fill || t.variant === r["fill-light"]) && !t.native && !t.multiselect && (Array.isArray(l.value) ? l.value.length > 0 : !!l.value) && (!!c.value || !!t.leadingIcon)
    ), Q = o(() => we(t, K.value, l.value)), W = o(() => !c.value || !h.value), X = o(() => (t.variant === r.fill || t.variant === r["fill-light"]) && !t.native && !t.multiselect && !!C.value && C.value !== "" && !!c.value), Y = o(
      () => Le(t, X.value, W.value)
    ), Z = o(() => !t.multiselect && !t.native && l.value && l.value !== ""), ee = o(() => Be(t, E.value)), t = B, C = o(() => {
      var e, u;
      if (t.variant === r.outline || t.variant === r["outline-light"]) {
        if (!l.value || Array.isArray(l.value) && l.value.length === 0)
          return t.placeholder;
      } else if (!l.value || Array.isArray(l.value) && l.value.length === 0 || Array.isArray(l.value) && l.value.length === 1 && l.value.includes(""))
        return "";
      return t.multiselect ? `Selected ${Array.isArray(l.value) && l.value.length} items` : typeof l.value == "string" || typeof l.value == "number" ? l.value : !Array.isArray(l.value) && ((e = l.value) == null ? void 0 : e.label) || !Array.isArray(l.value) && ((u = l.value) == null ? void 0 : u.value);
    });
    ve(() => {
      t.native || S.value.addEventListener("keydown", (e) => N(e)), typeof l.value == "string" && l.value && l.value.trim() || typeof l.value == "number" || typeof l.value == "object" && !Array.isArray(l.value) && l.value.value ? (a.isPreselectAction = !0, a.activeValues = typeof l.value == "object" && Object.hasOwn(l.value, "value") ? [l.value.value] : [l.value]) : Array.isArray(l.value) && l.value.length > 0 && !l.value.includes("") && (a.isPreselectAction = !0, a.activeValues = l.value.map((e) => typeof e == "string" || typeof e == "number" ? e : e && (e.value || e.label)));
    }), de(() => {
      var e;
      t.native || (e = S.value) == null || e.removeEventListener("keydown", (u) => N(u));
    });
    function le(e) {
      a.focusedIndex = -1;
    }
    function N(e) {
      e.key === "Enter" && (m.value ? (e.preventDefault(), a.activeValues.push($.value)) : a.focusedIndex === -1 && (a.focusedIndex = 0)), e.key === "Escape" && (e.preventDefault(), t.multiselect ? S.value.focus() : T.value.$el.children[0].focus()), e.key === " " && (m.value ? e.preventDefault() : a.focusedIndex === -1 && (a.focusedIndex = 0)), m.value && (e.key === "ArrowDown" && (e.preventDefault(), R(l.value, "down")), e.key === "ArrowUp" && (e.preventDefault(), R(l.value, "up")));
    }
    const m = v(!1);
    function R(e, u) {
      m.value && (u === "down" ? (a.focusedIndex = a.focusedIndex + 1, a.focusedIndex === x.value.listRef.children.length && (a.focusedIndex = 0)) : u === "up" ? (a.focusedIndex = a.focusedIndex - 1, a.focusedIndex < 0 && (a.focusedIndex = x.value.listRef.children.length - 1)) : a.focusedValue = e);
    }
    function te(e) {
      $.value = e;
    }
    function ae(e, u = !1, n = !1) {
      if (n) {
        t.multiselect ? Array.isArray(l.value) ? (l.value.splice(
          l.value.findIndex((s) => typeof s == "string" || typeof s == "number"),
          1
        ), l.value.push(e)) : l.value = [e] : (l.value = e, c.value = e.icon, h.value = e.typeLabel);
        return;
      }
      t.multiselect ? Array.isArray(l.value) ? (u ? l.value.splice(
        l.value.findIndex((s) => s === e.label || s === e.value || s === e),
        1
      ) : l.value.push({
        label: e.label,
        value: e.value,
        key: e.key || e.label
      }), a.activeValues = l.value.map((s) => typeof s == "string" || typeof s == "number" ? s : s && (s.value || s.label))) : (l.value = [e], a.activeValues = [e.value || e.label]) : (l.value = e, a.activeValues = [e.value || e.label], c.value = e.icon, h.value = e.typeLabel);
    }
    const a = fe({
      updateCustomSelectValue: ae,
      updateCustomSelectFocus: te,
      disableTabbing: !0,
      isCustomSelectList: !0,
      isPreselectAction: !1,
      activeValues: [""],
      focusedValue: void 0,
      focusedIndex: -1
    });
    pe(De, a);
    const se = o(() => t.multiselect ? `${t.name}-checkbox-group` : ""), oe = (e) => {
      const u = e.target;
      j("update:modelValue", u.value);
    };
    function ue(e) {
      E.value = e, m.value = e;
    }
    return (e, u) => (i(), d("label", {
      ref_key: "keyboardContext",
      ref: S,
      class: p(["input-select", [U.value, b(V), J.value]])
    }, [
      k(e.$slots, "iconSlot", {}, () => [
        (t.leadingIcon && !c.value) ?? (t.icon && !c.value) ? (i(), _(L, {
          key: 0,
          class: p(H.value),
          icon: t.leadingIcon ?? t.icon
        }, null, 8, ["class", "icon"])) : f("", !0)
      ]),
      !t.multiselect || t.native ? ye((i(), d("select", z({ key: 0 }, g, {
        "onUpdate:modelValue": u[0] || (u[0] = (n) => l.value = n),
        class: [M.value],
        name: t.name,
        ref_key: "inputExposed",
        ref: D,
        onInput: oe,
        "data-testid": `${g["data-testid"]}-native`,
        disabled: e.disabled
      }), [
        A("option", {
          hidden: "",
          disabled: "",
          checked: Array.isArray(l.value) && l.value.length === 0,
          value: []
        }, y(t.placeholder), 9, Ne),
        A("option", {
          hidden: "",
          disabled: "",
          checked: l.value === "",
          value: ""
        }, y(t.placeholder), 9, Re),
        A("option", {
          hidden: "",
          disabled: "",
          checked: Array.isArray(l.value) && l.value.every((n) => n === ""),
          value: [""]
        }, y(t.placeholder), 9, Fe),
        (i(!0), d(me, null, he(e.options, (n) => (i(), d("option", {
          value: n.value,
          key: n.key || n.value
        }, y(n.label), 9, ze))), 128)),
        Z.value ? (i(), d("option", {
          key: 0,
          value: l.value,
          checked: !0
        }, null, 8, Oe)) : f("", !0)
      ], 16, Me)), [
        [be, l.value],
        [Se, t.native]
      ]) : f("", !0),
      t.native ? f("", !0) : (i(), _(Te, {
        key: 1,
        "hide-indicator": !0,
        ref_key: "dropdownRef",
        ref: T,
        width: "auto",
        indicator: "right",
        bordered: t.variant === b(r).fill || t.variant === b(r)["fill-light"] ? void 0 : "primary",
        "close-on-click-outside": !0,
        "close-on-content-click": !t.multiselect,
        class: p(t.variant === b(r).outline || t.variant === b(r)["outline-light"] ? "select-custom-dropdown-outline" : ""),
        dropdownElementClass: "select-custom-dropdown",
        onDropdownToggled: ue
      }, {
        activator: I(({ onActivate: n, setActivatorRef: s }) => [
          A("button", z({
            class: [M.value, G.value],
            onClick: n,
            ref: (ne) => s(ne),
            "data-testid": g["data-testid"]
          }, g), [
            c.value ? (i(), _(L, {
              key: 0,
              class: p(q.value),
              icon: c.value,
              size: 24
            }, null, 8, ["class", "icon"])) : f("", !0),
            C.value ? (i(), d("span", {
              key: 1,
              class: p(Y.value)
            }, y(C.value), 3)) : f("", !0),
            h.value && !e.multiselect ? (i(), d("span", Ve, y(h.value), 1)) : f("", !0)
          ], 16, Pe)
        ]),
        content: I(() => [
          w($e, {
            ref_key: "listRef",
            ref: x,
            onMouseover: le,
            padding: "large",
            multiselect: se.value,
            truncate: !0,
            size: "medium"
          }, {
            default: I(() => [
              k(e.$slots, "default")
            ]),
            _: 3
          }, 8, ["multiselect"])
        ]),
        _: 3
      }, 8, ["bordered", "close-on-content-click", "class"])),
      e.label || e.$slots.labelSlot ? (i(), d("span", {
        key: 2,
        class: p(Q.value)
      }, [
        k(e.$slots, "labelSlot", {}, () => [
          ge(y(e.label), 1)
        ])
      ], 2)) : f("", !0),
      w(Ee, {
        assistiveText: t.assistiveText,
        errorMessage: t.errorMessage,
        invalid: t.invalid
      }, {
        default: I(() => [
          k(e.$slots, "assistiveTextSlot")
        ]),
        _: 3
      }, 8, ["assistiveText", "errorMessage", "invalid"]),
      w(L, {
        class: p(ee.value),
        icon: "chevronDown",
        size: 16
      }, null, 8, ["class"])
    ], 2));
  }
});
export {
  Ke as default
};
